<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="预约结果"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div v-if="showType == 1" class="succeed-parent">
        <div class="succeed-details">

          <img
            class="succeed-image"
            src="../../assets/imgs/officeImg@2x.png"
            mode=""
          />
          <div class="succeed-line" />
          <div class="succeed-address">{{ buildingNo + roomNumber }}</div>
          <div class="succeed-line" />

          <div class="succeed-line" />
          <div class="succeed-row">
            <div class="succeed-row-left">预约时间</div>
            <div class="succeed-row-right">{{ seltTime }}</div>
          </div>
        </div>
        <div v-if="oaPopupShow" class="oa-popup-parent" @click="hideOaPopup">
          <div class="oa-popup-content" catchtap="xxxxxx">
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 48px;
                align-self: center;
              "
            >
              <div
                style="width: 170px; height: 4px; background-color: #35b3ff"
              ></div>

              <div
                style="
                  padding: 10px 26px;
                  font-size: 22px;
                  font-weight: bold;
                  color: #ffffff;
                  border-radius: 44px;
                  background-color: #35b3ff;
                "
              >
                关注公众号
              </div>
              <div
                style="
                  width: 16px;
                  height: 16px;
                  background-color: #35b3ff;
                  border-radius: 8px;
                  margin-left: 12px;
                  margin-right: 28px;
                "
              ></div>
              <div
                style="width: 170px; height: 4px; background-color: #35b3ff"
              ></div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-left: 48px;
                margin-top: 50px;
              "
            >
              <img
                style="width: 80px; height: 56px"
                src="../../assets/imgs/appointment_result_step1.png"
              />
              <div
                style="
                  font-size: 32px;
                  font-weight: bold;
                  color: #007dff;
                  margin-left: 16px;
                "
              >
                关注公众号
              </div>
            </div>
            <official-account
              bindload="getOfficialAccount"
              binderror="getOfficialErr"
              class="official-accounts"
            ></official-account>
            <img
              style="
                align-self: flex-end;
                width: 30px;
                height: 42px;
                margin: 4px 120px 4px 0;
              "
              src="../../assets/imgs/appointment_result_hint_arrow.png"
            />
            <div
              style="
                align-self: flex-end;
                font-size: 24px;
                font-weight: bold;
                color: #666666;
                margin-left: 16px;
                margin-right: 54px;
              "
            >
              点击上方关注按钮即可关注公众号
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-left: 48px;
                margin-top: 50px;
              "
            >
              <img
                style="width: 80px; height: 56px"
                src="../../assets/imgs/appointment_result_step2.png"
              />
              <div
                style="
                  font-size: 32px;
                  font-weight: bold;
                  color: #007dff;
                  margin-left: 16px;
                "
              >
                授权登录
              </div>
            </div>
            <div
              style="
                margin-top: 32px;
                font-size: 28px;
                font-weight: bold;
                color: #333333;
                margin-left: 48px;
              "
            >
              获取你的昵称、头像、地区及性别
            </div>
            <div
              style="
                align-self: center;
                width: 648px;
                height: 108px;
                line-height: 108px;
                text-align: center;
                margin-top: 32px;
                font-size: 40px;
                font-weight: bold;
                color: #fff;
                background-color: #ff9d00;
                border-radius: 54px;
              "
              @click="toAuthorize"
            >
              点击授权
            </div>
          </div>
        </div>
      </div>
      <div v-else class="fail-parent">
        <img class="fail-image" src="../../assets/imgs/appointment_fail.png" />
        <div class="fail-hint">预约失败</div>
        <div class="fail-error-msg">{{ errorMsg }}</div>
        <div v-if="showRecharge" class="go-recharge">去充值</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showRecharge: false,
      oaShow: false, // 显示打开引导关注公众号界面按钮
      oaPopupShow: false, // 显示引导关注公众号界面
      showType: 1,
      errorMsg: '',
      typeName: '',
      roomNumber: '',
      buildingNo: '',
      seltTime: ''
    }
  },
  mounted () {
    const options = this.$route.query
    this.options = options
    this.showType = this.options.showType
    this.oaShow = this.options.subscribe === 0
    this.errorMsg = decodeURIComponent(this.options.errorMsg)
    this.typeName = decodeURIComponent(this.options.typeName)
    this.roomNumber = decodeURIComponent(this.options.roomNumber)
    this.buildingNo = this.options.buildingNo
    this.seltTime = decodeURIComponent(this.options.seltTime)
  },
  computed: {

  },
  methods: {
    doSub () {

    },
    goRecharge () {

    },
    toAuthorize () {

    },
    openOaPopup () {

    },
    hideOaPopup () {

    },
    bindOpenId () {

    },
    onClickLeft () {
      this.$router.replace('/order')
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  .succeed-details {
    box-sizing: border-box;
    width: 20.375rem;
    padding: 1rem 1rem 0px 1rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1.5625rem;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    background-color: #fff;
    box-shadow: 0px 0px 0.3125rem 0px rgba(1, 1, 1, 0.1);
  }
  .succeed-image {
    width: 18.75rem;
    height: 9.375rem;
    object-fit: contain;
    align-self: center;
  }
  .succeed-hint {
    margin-top: 1.3125rem;
    font-size: 1.5rem;
    font-weight: 550;
    margin-bottom: 1.25rem;
    letter-spacing: 0.25rem;
    color: #333;
    align-self: center;
  }
  .succeed-address {
    height: 2.8125rem;
    line-height: 3.125rem;
    font-size: 1.125rem;
    font-weight: 550;
    color: #333;
  }
  .succeed-line {
    background-color: #f4f4f4;
    height: 0.0625rem;
  }
  .succeed-row {
    height: 2.5rem;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
  .succeed-row-left {
    font-size: 0.875rem;
    color: #666;
  }
  .succeed-row-right {
    font-size: 0.875rem;
    color: #333;
  }
  .fail-parent {
    width: 100%;
    margin-top: 3.375rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .fail-parent {
    width: 100%;
    margin-top: 3.375rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .fail-image {
    width: 4.125rem;
    height: 4.3125rem;
  }
  .fail-hint {
    margin-top: 2.5rem;
    font-size: 1.5rem;
    font-weight: 550;
    letter-spacing: 0.25rem;
    color: #333;
  }
  .fail-error-msg {
    margin-top: 0.875rem;
    font-size: 0.875rem;
    color: #666;
  }
  .go-recharge {
    width: 9.875rem;
    height: 2.875rem;
    line-height: 2.875rem;
    text-align: center;
    border-radius: 1.4375rem;
    border: 0.0625rem solid #0487fe;
    color: #0487fe;
    margin-top: 4rem;
    font-size: 1rem;
    font-weight: 550;
  }
  .oa-parent {
    display: flex;
    flex-direction: column;
    position: absolute;
    justify-content: center;
    height: 13.5rem;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #fff;
  }
  .oa-hint {
    margin-left: 1.5625rem;
    font-size: 1.5rem;
    font-weight: bold;
    color: #007dff;
  }
  .oa-hint1 {
    margin-left: 1.5625rem;
    margin-top: 0.75rem;
    font-size: 1rem;
    font-weight: bold;
    color: #4587e7;
  }
  .open-oa-popup {
    align-self: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 1.875rem;
    width: 21rem;
    height: 3.375rem;
    border-radius: 1.5625rem;
    background-color: #007dff;
  }
  .open-oa-text {
    font-size: 1.25rem;
    font-weight: bold;
    color: #ffffff;
  }
  .open-oa-arrows {
    margin-left: 0.6875rem;
    width: 0.6875rem;
    height: 1.125rem;
  }

  .oa-popup-parent {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
  }
  .oa-popup-content {
    display: flex;
    flex-direction: column;
    position: absolute;
    height: 27.1875rem;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #fff;
    border-radius: 1rem 1rem 0 0;
  }
  .official-accounts {
    width: 20.25rem;
    margin-left: 1.5rem;
    margin-top: 1rem;
  }
}
</style>
